export default __webpack_public_path__ + "static/media/c-raving.d6a77982.png";